export function getPaymentAmount(checkout) {
  var _checkout$payNowTotal;
  return ((_checkout$payNowTotal = checkout.payNowTotalAfterGiftCard) == null ? void 0 : _checkout$payNowTotal.amount) || '0';
}
//# sourceMappingURL=getPaymentAmount.js.map